import styled from "styled-components";

interface IProps {
    error?: boolean;
    success?: boolean;
}

const StyledInputHelperText = styled.div<IProps>`
    padding: 0 ${(props) => props.theme.spacing.sm};
    color: ${(props) =>
        props.error
            ? props.theme.colors.alert.error
            : props.success
            ? props.theme.colors.alert.success
            : props.theme.colors.neutral.neutral600};
    font-size: ${(props) => props.theme.typography.body.small.fontSize};
    line-height: ${(props) => props.theme.typography.body.small.lineHeight};
    font-weight: ${(props) => props.theme.typography.body.small.fontWeight};
`;

export default StyledInputHelperText;
